module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/89/assets/images/c9e6b50f9d6b580e73194f471340f0c0.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Epic/Epic4.svg
// module id = ao7Y
// module chunks = 1